/** @jsx jsx */
import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { jsx, Flex, Box } from "theme-ui"
import Logo from "../components/Logo"

const Header = ({ siteTitle }) => {
  const [isMenuOpen, setMenuOpenState] = useState(false)
  return (
    <header
      style={{
        marginBottom: `1.45rem`,
        position: 'relative'
      }}
    >
      <Flex
        sx={{
          justifyContent: 'space-between',
          margin: `0 auto`,
          maxWidth: 960,
          padding: `1.45rem 1.0875rem`,
        }}
      >
        <Flex flexDirection={'row'}>
          <Box sx={{ width: '80px' }}>
            <Logo sx={{ width: '72px' }} />
          </Box>
          <h1 sx={{ margin: 0, ml: 3 }}>
            <Link
              to="/"
              sx={{
                textDecoration: `none`,
                fontSize: ['28px', '40px']
              }}
            >
              {siteTitle}
            </Link>
          </h1>
        </Flex>
        <Box>
          <h1 onClick={() => { setMenuOpenState(!isMenuOpen) }} sx={{ margin: 0, cursor: 'pointer' }}>&#9776;</h1>
        </Box>
        <Box sx={{ position: 'absolute', display: `${isMenuOpen ? 'block' : 'none'}`, top: 86, right: 0, background: '#eee', zIndex: 1, }}>
          <Box p={4}>
            <h4 sx={{ margin: 0 }}>
              <Link
                to="/about-us"
                style={{
                  textDecoration: `none`,
                }}
              >
                About Us
            </Link>
            </h4>
          </Box>

          <Box p={4}>
            <h4 sx={{ margin: 0 }}>
              <Link
                to="/facilities"
                style={{
                  textDecoration: `none`,
                }}
              >
                Facilities
            </Link>
            </h4>
          </Box>

          <Box p={4}>
            <h4 sx={{ margin: 0 }}>
              Our Doctors
          </h4>
          </Box>

          <Box p={4}>
            <h4 sx={{ margin: 0 }}>
              <Link
                to="/dr-manjit-singh-sidhu"
                style={{
                  textDecoration: `none`,
                }}
              >
                Dr Manjit Singh Sidhu
            </Link>
            </h4>
          </Box>

          <Box p={4}>
            <Link
              to="/dr-preeti-sidhu"
              style={{
                textDecoration: `none`,
              }}
            >
              <h4 sx={{ margin: 0 }}>
                Dr Preeti Sidhu
            </h4>
            </Link>
          </Box>

          <Box p={4}>
            <h4 sx={{ margin: 0 }}>
              <Link
                to="/health-education"
                style={{
                  textDecoration: `none`,
                }}
              >
                Health Education
            </Link>
            </h4>
          </Box>
        </Box>
      </Flex>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
